
import { defineComponent } from "vue";
import commentSecond from "@/views/post/components/commentSecond.vue";
import editor from "@/views/post/components/editor.vue";
import swiper from "@/views/post/components/swiper/swiper.vue";
import toast from "@/views/post/components/toast.vue";
import { delreply,add_reply_favorites } from "@/views/post/api/index.ts";
export default defineComponent({
  components: {
    commentSecond,
    editor,
    swiper,
    toast
  },
  props: {
    comment: {
      type: Array
    },
    post_id: {
      type: String
    },
    csrf: {
      type: String
    }
  },
  data(){
    return {
      commentList: this.comment,
      pingIndex: -1,
      reply_id:"",
      uid: parseInt((window.globalData as any).uid || 0),
      imglist:[],
      imglistindex:0
    }
  },
  setup(props, { emit }) {
    const gohome: (e: any) => void = (e: any) => {
      const uid = e.currentTarget.dataset.uid
      if(!Number(uid)) return
      const certified_type = e.currentTarget.dataset.certified_type
      const certified_id = e.currentTarget.dataset.certified_id
      let url = ""
      if(certified_type == 2){
        url = `/hospital/${certified_id}/`
      } else if(certified_type == 3){
        url = `/doctor/${certified_id}/zhuye/`
      } else {
        url = `/u${uid}`
      }
      window.open(`${window.location.origin}${url}`)
    };
    const del: (e: any) => void = (e: any) =>{
      if(confirm('确定要删除吗') == true){
        const reply_id = e.currentTarget.dataset.reply_id
        delreply({
          post_id: props.post_id,
          reply_id
        }).then(({code}) => {
          if(code === 200){
            emit("getlist")
          }
        })
      }
    };
    return {
      gohome,
      del
    };
  },
  methods:{
    showPinglun(e: any){
      this.pingIndex = e.currentTarget.dataset.index
      this.reply_id = e.currentTarget.dataset.reply_id
    },
    getList(){
      this.$emit("getlist")
    },
    getupdate(comment: Array<any>){
      console.log((this.commentList as any)[(this.pingIndex as any)])
      if(!(this.commentList as any)[(this.pingIndex as any)].comment){
        (this.commentList as any)[(this.pingIndex as any)].comment = []
      }
      (this.commentList as any)[(this.pingIndex as any)].comment.unshift(comment)
      this.pingIndex = -1
    },
    zan(e: any){
      const index = e.currentTarget.dataset.index
      const reply_id = e.currentTarget.dataset.reply_id
      if (this.uid === 0) {
        window.sy.login.popup()
        return
      }
      add_reply_favorites({
        post_id: this.post_id,
        reply_id,
        type: 1,
      }).then(({errorCode,errorMsg}) => {
        if (errorCode === 0) {
          (this.commentList as any)[index].is_favor = 1;
          (this.commentList as any)[index].ding_cnt = parseInt((this.commentList as any)[index].ding_cnt) + 1
        } else {
          (this.$refs.toast as any).show(errorMsg)
        }
      })
    },
    shoImg(e: any){
      const index = e.currentTarget.dataset.index
      const i = e.currentTarget.dataset.i
      const arr = (this.commentList as any)[index].content
      const temp: any = []
      arr.forEach((element: any) => {
        if(element.ident == 'lnimage'){
          temp.push(element);
        }
      });
      temp.forEach((element: any,index: any) => {
        if(arr[i].u == element.u){
          this.imglistindex = index.toString();
        }
      });
      (this.imglist as any) = temp
    },
    close(){
      this.imglist = []
    }
  },
  watch:{
    comment: {
      handler() {
        this.commentList= this.comment
      }
    }
  }
});
